import { getTokens } from '../../../../../auth/AuthState';
import API from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getClinicianProfileBasic } from '../../../../../store/ai2';

export const useUpdateTeamTasks = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const postUpdateTeamTasks = async (updateTeamTasksPayload) => {
    setIsLoading(true);
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      const payload = {
        tenancyId: updateTeamTasksPayload.selectedTenancy?.tenancy_id,
        tasks: updateTeamTasksPayload.tasks,
      };
      const result = await API.post(`updateTeamTasks`, { ...payload }, options);

      const getTaskData = await getClinicianProfileBasic();
      await dispatch(getTaskData);
      return result;
    } catch (error) {
      console.error('An error occurred during update team tasks', error);
      setErrorMessage(
        error?.response?.data?.message || 'Unknown error in update team tasks',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postUpdateTeamTasks,
    errorMessage,
    isLoading,
  };
};
